module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921042649_T.f1b0641e.jpg";